import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

// import { history as historyPropTypes } from 'history-prop-types';
import { deleteMyData, exportMyData, getDataRequests } from '../../../../ducks/user/mydata';
import Content from '../../components/Content';
import DataCard from './DataCard';
import Header from '../../components/Header';
import Loader from '../../components/Loader';
import Subheader from '../../components/Subheader';
import { absolute } from '../../components/AnimatedRoutes';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    state: PropTypes.string,
    type: PropTypes.string,
    created_at: PropTypes.string,
  })),
  dispatch: PropTypes.func.isRequired,
  // history: PropTypes.shape(historyPropTypes),
  loading: PropTypes.bool,
  saving: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
  }),
};

class Data extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getDataRequests());
  }

  onDeleteData = () => {
    const { dispatch } = this.props;
    dispatch(deleteMyData());
  }

  onExportData = () => {
    const { dispatch } = this.props;
    dispatch(exportMyData());
  }

  render() {
    const {
      loading,
      saving,
      data,
      history,
    } = this.props;

    const exporting = data && data.filter((req) => req && req.type === 'export')[0];
    const deleting = data && data.filter((req) => req && req.type === 'delete')[0];

    return (
      <>
        <Header onBack={() => history.stackPop()}>
          <FormattedMessage
            id="mydata.header"
            description="Header text of My Data header"
            defaultMessage="My data"
          />
        </Header>
        <Content>
          <Loader loading={loading} />
          { !loading
            && (
              <>
                <Subheader>
                  <FormattedMessage
                    id="mydata.exporting.subheader"
                    description="Sub header text for export data"
                    defaultMessage="Export your personal data"
                  />
                </Subheader>
                <DataCard
                  request={exporting}
                  mid={(
                    <p>
                      <FormattedMessage
                        id="mydata.exporting.mid"
                        defaultMessage="Exporting your personal data will create a file with all personal data we have collected and stored related to you. A link to this file will be sent to the email address associated with this account."
                      />
                    </p>
)}
                  btnText={(
                    <FormattedMessage
                      id="mydata.exporting.btnText"
                      defaultMessage="Export my personal data"
                    />
)}
                  btnFunc={this.onExportData}
                  saving={saving}
                />
                <Subheader>
                  <FormattedMessage
                    id="mydata.deleting.subheader"
                    defaultMessage="Delete account and remove personal data"
                  />
                </Subheader>
                <DataCard
                  request={deleting}
                  mid={(
                    <>
                      <p>
                        <FormattedMessage
                          id="mydata.deleting.mid.1"
                          defaultMessage="By deleting your account, you will permanently remove your account and all data related to it. This action is non-reversible."
                        />
                      </p>
                      <p>
                        <FormattedHTMLMessage
                          id="mydata.deleting.mid.2"
                          defaultMessage="<strong>Please note:</strong> if you have tickets to any upcoming event when deleting your data, your tickets will no longer be usable and we <strong>cannot longer guarantee you will be let in at the event</strong>."
                        />
                      </p>
                    </>
)}
                  btnText={(
                    <FormattedMessage
                      id="mydata.deleting.btnText"
                      defaultMessage="Delete account"
                    />
)}
                  btnFunc={this.onDeleteData}
                  saving={saving}
                />
              </>
            )}
        </Content>
      </>
    );
  }
}

Data.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    data: state.getIn(['mydata', 'data']),
    loading: state.getIn(['mydata', 'loading']),
    saving: state.getIn(['mydata', 'saving']),
    error: state.getIn(['mydata', 'error']),
  };
}

export default injectIntl(connect(mapStateToProps)(absolute(Data)));
